import produce from "immer";
import { CandidateState } from "../candidateState";
import { CombinedCandidatesFeatureActionTypes } from "../combinedCandidatesFeatureActions";
import names from "./candidateActionTypes";

export const candidateReducer = (
    state: CandidateState,
    action: CombinedCandidatesFeatureActionTypes
) =>
    produce(state, draft => {
        switch (action.type) {
            case names.LOAD_CANDIDATE: {
                draft.ui.isCandidateLoading = true;
                break;
            }

            case names.LOAD_CANDIDATE_SUCCESS: {
                draft.data.currentJobId = action.payload.jobId;
                draft.data.currentLeadId = action.payload.leadId;
                draft.data.candidate = action.payload.candidate;
                draft.ui.isCandidateLoading = false;
                draft.ui.error = undefined;

                break;
            }

            case names.LOAD_CANDIDATE_FAILURE: {
                draft.ui.isCandidateLoading = false;
                draft.ui.error = {
                    type: "loading",
                    apiError: action.payload.apiError,
                };
                break;
            }

            case names.LOAD_CANDIDATE_SHARE: {
                draft.ui.isCandidateLoading = true;
                break;
            }

            case names.LOAD_CANDIDATE_SHARE_SUCCESS: {
                draft.data.candidateShareInfo = action.payload.candidateShare;
                draft.ui.isCandidateLoading = false;
                draft.ui.error = undefined;

                break;
            }

            case names.LOAD_CANDIDATE_SHARE_FAILURE: {
                draft.ui.isCandidateLoading = false;
                draft.ui.error = {
                    type: "loading",
                    apiError: action.payload.apiError,
                };
                break;
            }

            case names.MANAGE_CANDIDATE_FEEDBACK: {
                draft.ui.isFeedbackUpdating = true;
                break;
            }

            case names.MANAGE_CANDIDATE_FEEDBACK_SUCCESS: {
                draft.ui.isFeedbackUpdating = false;
                break;
            }

            case names.MANAGE_CANDIDATE_FEEDBACK_FAILURE: {
                draft.ui.isFeedbackUpdating = false;
                draft.ui.error = {
                    type: "updateFeedback",
                    apiError: action.payload.apiError,
                };
                break;
            }
        }
    });
